export default function SvgView() {
  return (
    <svg
      width="54"
      height="32"
      viewBox="0 0 54 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M26.5827 10.1053L34.3636 15.4274V15.1579C34.3636 13.8179 33.5878 12.5327 32.2069 11.5851C30.8259 10.6376 28.953 10.1053 27 10.1053H26.5827ZM16.0282 11.4526L19.8327 14.0632C19.71 14.4168 19.6364 14.7705 19.6364 15.1579C19.6364 16.4979 20.4122 17.7831 21.7931 18.7306C23.1741 19.6782 25.047 20.2105 27 20.2105C27.54 20.2105 28.08 20.16 28.5955 20.0758L32.4 22.6863C30.7555 23.2421 28.9391 23.5789 27 23.5789C23.7451 23.5789 20.6235 22.6917 18.3219 21.1125C16.0203 19.5332 14.7273 17.3913 14.7273 15.1579C14.7273 13.8274 15.2182 12.5811 16.0282 11.4526ZM2.45455 2.13895L8.05091 5.97895L9.15545 6.73684C5.10545 8.92632 1.91455 11.7895 0 15.1579C4.24636 22.5516 14.7273 27.7895 27 27.7895C30.8045 27.7895 34.4373 27.2842 37.7509 26.3747L38.8064 27.0821L45.9736 32L49.0909 29.8611L5.57182 0M27 6.73684C30.2549 6.73684 33.3765 7.62406 35.6781 9.20331C37.9797 10.7826 39.2727 12.9245 39.2727 15.1579C39.2727 16.2358 38.9536 17.28 38.3891 18.2232L45.5809 23.1579C49.2627 21.0526 52.2082 18.2905 54 15.1579C49.7536 7.76421 39.2727 2.52632 27 2.52632C23.5636 2.52632 20.2745 2.94737 17.1818 3.70526L22.5082 7.32632C23.9073 6.95579 25.4045 6.73684 27 6.73684Z"
        fill="#F8F8F8"
      />
    </svg>
  );
}
